/**
 * Links to external resources.
 */
export const LINKS = {
  open_finance: 'https://consentimento.openbanking.caixa.gov.br/?recepcao=1&redirect_uri=https://www.caixa.gov.br/open-banking/',
};
